import * as React from "react";
import { SummaryViewStyle } from "./text-summary-view-style";

interface SummaryViewProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    readonly title?: string;
    readonly subtitle?: string;
}

const TextSummaryView: React.FunctionComponent<SummaryViewProps> = props => {
    const { title, subtitle, ref, ...rest } = props;

    return (
        <SummaryViewStyle {...rest}>
            <div className="summary-title">{title}</div>
            <div className="summary-subtitle">{subtitle}</div>
        </SummaryViewStyle>
    );
};

export default TextSummaryView;
